import gql from 'graphql-tag';

export default gql`
  fragment AllDetailsPotential on VMIOrder {
    orderId
    siteId
    vmiIndicator
    deliveryEta
    timeleftfordelivery
    currentStatus
    createdDate
    items {
      statusChangedTimestamp
      currentStatus
      deliveryVolume
      ouId
      sapShipmentNumber
      tankId
      vmiIndicator
      productCode
      deliveryEta
      productName
      vehicleDistance
      siteId
      timeleftfordelivery
      orderId
      deliveryStatus
    }
    soldTo {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
    }
    shipTo {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
      smhActiveUser
    }
  }
`;
